import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/libs/i18n'
import auth from './routes/auth'
import profile from './routes/profile'
import documents from './routes/documents'
import Dashboard from './routes/dashboard'
import tickets from './routes/tickets'
import messages from './routes/messages'
import modules from '@/modules'

Vue.use(VueRouter)
const themeName = process.env.VUE_APP_THEME_NAME

const moduleRouters = []
Object.keys(modules).forEach(key => {
  if (modules[key].router) {
    modules[key].router.forEach(item => {
      moduleRouters.push(item)
    })
  }
})
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: `/${i18n.locale}/dashboard`,
    },
    {
      path: '/:lang',
      redirect: `/${i18n.locale}/dashboard`,
      name: 'site',
      meta: {
        middleware: 'auth',
      },
      component: {
        render(c) {
          return c('router-view')
        },
      },
      children: [
        ...moduleRouters,
        ...auth,
        ...profile,
        ...documents,
        ...Dashboard,
        ...tickets,
        ...messages,
        {
          path: '/:lang/error-404',
          name: 'error-404',
          component: () => import(`@/views/${themeName}/error/Error404.vue`),
          meta: {
            middleware: 'both',
            layout: 'full',
          },
        },
        {
          path: '/:lang/maintenance',
          name: 'maintenance',
          component: () => import(`@/views/${themeName}/error/maintenance.vue`),
          meta: {
            pageTitle: 'maintenance',
            middleware: 'both',
            layout: 'full',
          },
        },
        {
          path: '/:lang/logout',
          name: 'logout',
          meta: {
            middleware: 'auth',
            layout: 'full',
          },
        },
        {
          path: '*',
          redirect: '/:lang/error-404',
        },
      ],
    },
  ],
})

export default router
